import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ContentLoader from "react-content-loader";
import MaterialTable from "material-table";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

import { getTrans as t } from "../../../Localization/translations"
import Helper from "../../../Helper";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import DetailsReceiptService from '../../../services/receipts/detailViewReceipt';
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import DocumentUpload from "../../../services/document/documentupload";
import { set } from "date-fns";
import ApprovalAction from "../../Approvals/ApprovalAction";
import ApprovalDetails from "../../Approvals/ApprovalDetails";


function ShowRecipts({ customerPermission, setCustomData }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true)
  const { state } = useLocation();
  const invoicePaidRef = useRef(null);

  const [receipt_number, setReceipt_number] = useState("")
  const [receipt_date, setReceipt_date] = useState("")
  const [receipt_amount, setReceipt_amount] = useState(0)
  const [applied_amount, setApplied_amount] = useState(0)
  const [remittance_bank, setRemittance_bank] = useState("")
  const [receipt_method, setReceipt_method] = useState("")
  const [receipt_reference, setReceipt_reference] = useState("");
  const [status, setStatus] = useState("");
  const [overide_application, setOveride_application] = useState("");
  const [customer_id, setCustomer_id] = useState("")
  const [contract_id, setContract_id] = useState("")
  const [attribute, setAttribute] = useState([])
  const [extrafiledreceipt, setExtraFiled] = useState([])
  const [object_name, setObject_name] = useState('Receipts')
  const [selectedRows, setSelectedRows] = useState([]);
  const [comments, setComments] = useState("");
  const [reverse_comment, setReverse_comment] = useState("");
  const [cashLoading, setCashLoading] = useState(false)

  //approval
  const [isApprovalRequired, setIsApprovalRequired] = useState(false);
  const [approvalTaskId, setApprovalTaskId] = useState(null);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState("Draft");
  const [approvalRequestId, setApprovalRequestId] = useState(null);

  const normalizeStatus = (status) => {
    if (!status) return "Draft";
    const s = status.toLowerCase();

    if (s === "pending") return "Pending";
    if (s === "approved") return "approved";
    if (s === "rejected") return "rejected";
    return "Draft";
  };

  const approvalRequest = state
    ? {
      id: normalizeStatus(approvalStatus) === "Draft"
        ? state
        : approvalTaskId,
      status: normalizeStatus(approvalStatus)
    }
    : null;


  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then(
      (response) => {
        setExtraFiled(response.data.existrecipt)
      }
    )

  }
  let navigate = useNavigate();

  const handleView = (id, status) => {
    navigate("/billing/viewinvoices", { state: id })
  }

  const refresh = () => {
    DetailsReceiptService.getReceiptDetail(state).then(
      (response) => {
        setReceipt_number(response.data.receipt.receipt_number)
        setReceipt_date(response.data.receipt.receipt_date)
        setReceipt_amount(response.data.receipt.receipt_amount)
        setApplied_amount(response.data.receipt.applied_amount)
        setStatus(response.data.receipt.status)
        setComments(response.data.receipt.comments);
        setReverse_comment(response.data.receipt.reverse_comment);
        setRemittance_bank(response.data.receipt.remittance_bank)
        setReceipt_method(response.data.receipt.receipt_method)
        setReceipt_reference(response.data.receipt.receipt_reference)
        setOveride_application(response.data.receipt.overide_application)
        setCustomer_id(response.data.receipt.customer_id)
        setContract_id(response.data.receipt.contract_id)
        setItems(response.data.receipt_applicattion)
        setAttribute([
          { attribute0: response.data.receiptattribute1 },
          { attribute1: response.data.receiptattribute2 },
          { attribute2: response.data.receiptattribute3 },
          { attribute3: response.data.receiptattribute4 },
          { attribute4: response.data.receiptattribute5 },
          { attribute5: response.data.receiptattribute6 },
          { attribute6: response.data.receiptattribute7 },
          { attribute7: response.data.receiptattribute8 },
          { attribute8: response.data.receiptattribute9 },
          { attribute9: response.data.receiptattribute10 },
          { attribute10: response.data.receiptattribute11 },
          { attribute11: response.data.receiptattribute12 },
          { attribute12: response.data.receiptattribute13 },
          { attribute13: response.data.receiptattribute14 },
          { attribute14: response.data.receiptattribute15 },
        ])
        setLoading(false)
      },
    )
  }

  const handleReceiptReverse = (event) => {
    event.preventDefault();
    axios.post(API + `receipts/reverse_receipt_applications/${state}/`, { invoice_ids: selectedRows }, { headers: authHeader() })
      .then(response => {
        if (response.data.success === 1) {
          toast.success(response.data.response, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setTimeout(() => {
            setSelectedRows([])
            navigate("/receipts");
            // refresh()
          }, 2000)

        }
        else {
          toast.error(response.data.error, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        }
      })
      .catch((error) => {
        toast.error('Something went wrong,', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })

      });

  };



  useEffect(() => {
    getExtrafiled()
    DetailsReceiptService.getReceiptDetail(state).then(
      (response) => {
        setReceipt_number(response.data.receipt.receipt_number)
        setReceipt_date(response.data.receipt.receipt_date)
        setReceipt_amount(response.data.receipt.receipt_amount)
        setApplied_amount(response.data.receipt.applied_amount)
        setStatus(response.data.receipt.status)
        setComments(response.data.receipt.comments);
        setReverse_comment(response.data.receipt.reverse_comment);
        setRemittance_bank(response.data.receipt.remittance_bank)
        setReceipt_method(response.data.receipt.receipt_method)
        setReceipt_reference(response.data.receipt.receipt_reference)
        setOveride_application(response.data.receipt.overide_application)
        setCustomer_id(response.data.receipt.customer_id)
        setContract_id(response.data.receipt.contract_id)
        setItems(response.data.receipt_application)
        setAttribute([
          { attribute0: response.data.receiptattribute1 },
          { attribute1: response.data.receiptattribute2 },
          { attribute2: response.data.receiptattribute3 },
          { attribute3: response.data.receiptattribute4 },
          { attribute4: response.data.receiptattribute5 },
          { attribute5: response.data.receiptattribute6 },
          { attribute6: response.data.receiptattribute7 },
          { attribute7: response.data.receiptattribute8 },
          { attribute8: response.data.receiptattribute9 },
          { attribute9: response.data.receiptattribute10 },
          { attribute10: response.data.receiptattribute11 },
          { attribute11: response.data.receiptattribute12 },
          { attribute12: response.data.receiptattribute13 },
          { attribute13: response.data.receiptattribute14 },
          { attribute14: response.data.receiptattribute15 },
        ])
        setLoading(false)
      },
    )

    // Approval History
    axios.get(API + `approvals/history/${state}/`, {
      headers: authHeader(),
      params: { type: "receipt" }
    })
      .then(res => {
        setApprovalHistory(res.data || []);
      })
      .catch(() => setApprovalHistory([]));

    // Approval Task
    axios.get(API + `approvals/task/${state}/`, {
      headers: authHeader(),
      params: { type: "receipt" }
    })
      .then(res => {
        const data = res.data || {};

        setApprovalTaskId(data.task_id || null);
        setApprovalRequestId(data.request_id || null);

        const status = data.status?.toLowerCase() || "draft";

        const formattedStatus =
          status === "pending" ? "Pending" :
            status === "approved" ? "approved" :
              status === "rejected" ? "rejected" :
                "Draft";

        setApprovalStatus(formattedStatus);
      })
      .catch(() => {
        setApprovalStatus("Draft");
        setApprovalTaskId(null);
      });

  }, [state])

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name
    })
  }, [object_name, setCustomData, state])


  useEffect(() => {
    axios.get(API + "accounting/transactiontypesview/?", {
      headers: authHeader()
    })
      .then(res => {
        console.log("API DATA:", res.data);

        // ✅ FIX 1: correct data path
        const transactionList = res.data.data || [];

        console.log("Transaction List:", transactionList);

        // ✅ FIX 2: correct find condition
        const cashReceipt = transactionList.find(
          (item) =>
            item.transaction_type === "Cash Receipt" ||
            item.description === "Cash Receipt"
        );

        console.log("FINAL CASH RECEIPT:", cashReceipt);

        if (cashReceipt) {
          const approvalFlag = (cashReceipt.approval || "")
            .trim()
            .toUpperCase();

          setIsApprovalRequired(approvalFlag === "Y");
        } else {
          console.warn("Cash Receipt NOT FOUND");
        }
      })
      .catch(err => {
        console.error("API ERROR:", err);
      });
  }, []);

  const handleRowSelectionChange = (rows) => {
    // setSelectedRows(rows.map(row => row.invoice_id.id));
    const uniqueInvoiceIds = [...new Set(rows.map(row => row.invoice_id.id))];
    setSelectedRows(uniqueInvoiceIds);
  };



  const handleCashReceiptReversal = (reverseComment) => {
    // event.preventDefault();
    // setSuccessful(false)
    setCashLoading(true)
    axios.post(API + `receipts/reverse_cash_receipt/`, { receipt_id: state, reverse_comment: reverseComment }, { headers: authHeader() })
      .then(response => {
        if (response.data.success === 1) {
          toast.success(response.data.response, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setTimeout(() => {
            setCashLoading(false);
            refresh()
            // navigate("/receipts/viewreceipts", { state: state })
            // setSelectedRows([])
          }, 2000)

        }
        else {
          setCashLoading(false)
          toast.error(response.data.error, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        }
      })
      .catch((error) => {
        setCashLoading(false)
        toast.error('Something went wrong,', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })

      });
  };

  const handleCashReceiptReversalconfirmAlert = () => {
    let reverseComment = "";

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h6>
              Confirm reversal and provide reason.
            </h6>

            {/* ✅ TEXTAREA ADDED */}
            <textarea
              className="form-control mt-3"
              placeholder="Enter reverse reason..."
              onChange={(e) => (reverseComment = e.target.value)}
            />

            <div className="react-confirm-alert-button-group mt-3">
              <button onClick={onClose}>Cancel</button>
              <button
                onClick={() => {
                  handleCashReceiptReversal(reverseComment);
                  onClose();
                }}
              >
                Save
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handlesmoothInvoice = () => {
    invoicePaidRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [documents, setDocuments] = useState([]);

  const recordsPerPage = 2;

  let indexOfLastRecord, indexOfFirstRecord, currentDocuments, totalPages;
  if (customerPermission !== 'Customer') {
    indexOfLastRecord = currentPage * recordsPerPage;
    indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);
    totalPages = Math.ceil(documents.length / recordsPerPage);
  } else {
    currentDocuments = documents;
  }


  const handleDownload = (fileUrl) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  useEffect(() => {
    console.log('receipt_number', receipt_number)
    DocumentUpload.viewListuploadFilterview(receipt_number, state).then((res) => {
      setDocuments(res.data.data)
    }).catch((e) => {
      console.log('e', e)
    })
  }, [receipt_number, state]);

  const handleUpload = () => {
    navigate('/doc', {
      state: {
        reference_id: state,
        reference_name: receipt_number
      }
    });
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        {
          loading === false ? (
            <>
              <div className="header pt-3 mb-3">
                <h5>
                  {t("Receipts")}
                </h5>
                <h6>
                  <Link to="/receipts" className="tc">{t("Receipts")}</Link> / <span>{t("View Receipt")}</span></h6>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="col-md-7">
                      <div className="card" >
                        <div className="card-body">
                          <div className="row">
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt Method")} <Tooltip content={t("ReceiptMethod_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {receipt_method ? receipt_method : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt No")} <Tooltip content={t("ReceiptNo_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex ">
                                  <span className="party-detail-font">
                                    {receipt_number ? receipt_number : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Customer")} <Tooltip content={t("Customer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {customer_id ? customer_id.customer_name : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Applied Amount")} <Tooltip content={t("AppliedAmountReceipt_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex ">
                                  <span className="party-detail-font">
                                    {Helper.Amount(Math.abs(applied_amount))}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Contract Number")} <Tooltip content={t("ContractNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {contract_id ? contract_id.contract_number : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt Amount")} <Tooltip content={t("ReceiptAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {Helper.Amount(receipt_amount)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt Date")} <Tooltip content={t("ReceiptDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {receipt_date ? Helper.DateNormal(receipt_date) : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Comments")} <Tooltip content={t("Comments_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {(comments ? comments : "None")}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Remittance Bank")} <Tooltip content={t("RemittanceBank_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {remittance_bank ? remittance_bank : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt Reference")} <Tooltip content={t("ReceiptReference_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {receipt_reference ? receipt_reference : "None"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Receipt Status")} <Tooltip content={t("ReceiptStatus_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {status ? status : "None"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                <label className="sub-title tc">{t("Reverse Reason")} <Tooltip content={t("reverseComments_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className="party-detail-font">
                                    {(reverse_comment ? reverse_comment : "None")}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {
                              extrafiledreceipt.map((key, index) => (
                                <>
                                  <div className="row" style={{ display: key.enable === 'True' ? true : "none" }}>
                                    <div className="col-xl-6 d-flex" style={{ display: key.enable === 'True' ? true : "none", justifyContent: 'space-between' }}>
                                      <label className="sub-title tc" style={{ display: key.enable === 'True' ? true : "none" }}>{key.label}</label>
                                      <div className="col-xl-6 d-flex" style={{ display: key.enable === 'True' ? true : "none", justifyContent: 'space-between' }}>
                                        <span className="party-detail-font" style={{ display: key.enable === 'True' ? true : "none" }}>
                                          {attribute[index]['attribute' + index] ? attribute[index]['attribute' + index] : "None"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))}

                          </div>
                          {
                            status !== "Draft" & status !== "Unapplied" & status !== "Reversed" & status !== "Cancelled" ?
                              <button
                                disabled={cashLoading ? true : false}
                                type="button"
                                onClick={handlesmoothInvoice}
                                className="btn-apply border-0 btn btn-primary mt-3 btn-gradient-primary btn-sm"
                                style={{ marginLeft: '10px' }}
                              >
                                {cashLoading === false ? (
                                  t("Application Reversal")
                                ) : (
                                  <ButtonLoading />
                                )}
                              </button> : ""
                          }
                          {
                            status !== "Draft" & status !== "Unapplied" & status !== "Reversed" & status !== "Cancelled" ?
                              <button
                                disabled={cashLoading ? true : false}
                                type="button"
                                onClick={handleCashReceiptReversalconfirmAlert}
                                className="btn-apply border-0 btn btn-primary mt-3 btn-gradient-primary btn-sm"
                                style={{ marginLeft: '10px' }}
                              >
                                {cashLoading === false ? (
                                  t("Reverse Receipt")
                                ) : (
                                  <ButtonLoading />
                                )}
                              </button> : ""
                          }

                        </div>
                      </div>
                    </div>
                    {
                      customerPermission !== 'Customer' &&
                      <div className="col-md-5">
                        <div className="card" >
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">Documents ({documents.length})</h5>
                              <button className="btn btn-primary" onClick={handleUpload}>UPLOAD</button>
                            </div>
                            <div className="documents-list">
                              {currentDocuments && currentDocuments.map(doc => (
                                <div className="document-item" key={doc.id}>
                                  <div className="document-icon">
                                    {doc.type === 'pdf' ? '📄' :
                                      doc.type === 'doc' || doc.type === 'docx' ? '📝' :
                                        doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
                                          '📁'}
                                  </div>
                                  <div className="document-info">
                                    <div className="document-name">{doc.title}</div>
                                    <div className="document-metadata">
                                      {Helper.DateNormal(doc.uploaded_at)}
                                    </div>
                                    <div className="document-tags">
                                      {doc.tags.split(',').map((tag, index, arr) => (
                                        <span key={index} className="tag-pill">{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
                                      ))}
                                    </div>
                                  </div>
                                  <div className="document-actions">
                                    <button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                      onClick={() => handleDownload(doc.file)}
                                    >
                                      Download
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div className="pagination-controls d-flex justify-content-between mt-3">
                                <button
                                  className="pag-btn"
                                  onClick={handlePrevious}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>

                                <span>Page {currentPage} of {totalPages}</span>

                                <button
                                  className="pag-btn"
                                  onClick={handleNext}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>

                            </div>
                          </div>
                        </div>
                        {isApprovalRequired && (
                          <div className="card mt-3">

                            {approvalStatus?.toLowerCase() === "approved" ||
                              approvalStatus?.toLowerCase() === "rejected" ? (

                              <ApprovalDetails
                                approvalHistory={approvalHistory}
                                approvalRequestId={approvalRequestId}
                              />

                            ) : (
                              approvalRequest && (
                                <ApprovalAction
                                  request={approvalRequest}
                                  onSuccess={() => window.location.reload()}
                                />
                              )
                            )}

                          </div>
                        )}
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className=" row">
                    <label className="col-lg-5 mt-2   col-form-label" style={{ color: '#000000' }}>{t("Applied Invoices")}</label>
                    <div className="col-lg-12 mt-1">


                      <div className="body">
                        <div className="table-responsive p-0" ref={invoicePaidRef}>
                          <MaterialTable
                            style={{
                              padding: "0.5rem 0.5rem", backgroundColor: "var(--bs-table-bg)",
                              borderBottomWidth: "1px",
                              boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}

                            columns={[
                              {
                                title: `${t("Invoice Number")}`,
                                field: "invoice_id.invoice_number",
                                render: rowDate => <><div className="d-xl-none tc d-md-none d-lg-none hyperlink">{t("Invoice Number")}</div>
                                  <div className="hyperlink" onClick={() => handleView(rowDate.invoice_id.id)}>{rowDate.invoice_id.invoice_number}</div></>,
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left"
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12
                                },
                              },
                              {
                                title: `${t("Invoice Type")}`,
                                field: "invoice_line_id.line_type",
                                render: rowDate => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Invoice Type")}</div><div>{rowDate.invoice_line_id.line_type}</div></>,
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left"
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12
                                }
                              },
                              {
                                title: `${t("Line Amount")}`,
                                field: "invoice_line_id.line_amount",
                                render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >{t("Line Amount")}</div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(parseFloat(rowData.invoice_line_id.line_amount))}</div></>,
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "right"
                                },
                                // cellStyle: {
                                //     textAlign: "right",
                                //     fontSize: 12
                                // }
                              }, {
                                title: `${t("Applied Amount")}`,
                                field: "receipt_applied_amount",
                                render: rowData => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >{t("Applied Amount")}</div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {/* {Helper.Amount(parseFloat(rowData.invoice_line_id.line_amount + parseFloat(rowData.invoice_line_id.tax_amount ? rowData.invoice_line_id.tax_amount : 0)) - parseFloat(rowData.invoice_line_id.balance_amount))} */}
                                    {rowData.receipt_applied_amount ? Helper.Amount(rowData.receipt_applied_amount) : 0.00}
                                  </div></>,
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "right"
                                },
                                // cellStyle: {
                                //     textAlign: "right",
                                //     fontSize: 12
                                // }
                              },
                            ]}
                            data={items}
                            onSelectionChange={handleRowSelectionChange}
                            localization={{
                              toolbar: {
                                searchPlaceholder: "Search Party"
                              }
                            }}

                            options={{
                              headerStyle: {
                                backgroundColor: "white",
                                color: "#245C7F",
                                fontSize: 11,
                              },
                              rowStyle: (rowData, index) => {
                                if (index % 2) {
                                  return { backgroundColor: "#fff" }
                                }
                              },

                              sorting: true,
                              search: false,
                              toolbar: false,
                              //Pagination
                              paging: true,
                              pageSize: 10,       // make initial page size
                              emptyRowsWhenPaging: false,   // To avoid of having empty rows
                              pageSizeOptions: [10, 20, 25, 50],
                              paginationType: "stepped",
                              showFirstLastPageButtons: false,
                              actionsColumnIndex: -1,
                              selection: true,
                              showTextRowsSelected: false,
                            }}


                          />
                        </div>


                      </div>
                    </div>
                    {
                      selectedRows.length > 0 ?
                        <div className="">
                          <button className="btn btn-primary btn-sm"
                            onClick={(e) => handleReceiptReverse(e)}
                          >
                            {t('Reverse Application ')}                      </button>
                        </div>
                        : ""

                    }
                  </div>
                </div>

              </div>

            </>
          ) : (
            <ContentLoader
              viewBox="0 0 400 160"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
              <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
              <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
              <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
              <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
              <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
            </ContentLoader>
          )
        }
      </div>
    </>
  )
}

export default ShowRecipts
